<div class="access-container">
    <h3 class="access-container-header">{{messageToDisplay.header}}</h3>
    <p class="access-container-body">{{messageToDisplay.body}}</p>
</div>